/* eslint-disable consistent-return */
import React, { FC } from 'react';
import Barcode from 'react-barcode';
import styled from 'styled-components';
import logo from '../../../../../../assets/somer-vector.png';

import { INotfisResponse } from '../../../../../../interfaces/response/Notfis/INotfisResponse';
import { formatarData } from '../../../../../../util/format';

export interface OrderTagProps {
  tagData: INotfisResponse;
  etiqueta: string;
}

const OrderCbaTag: FC<OrderTagProps> = ({ tagData, etiqueta }): JSX.Element => {
  const handleGetVolume = (): string => {
    let volumeAux = 1;

    tagData.notfis.volumes.forEach((volume) => {
      if (etiqueta.includes(volume.etiqueta.trim())) volumeAux += volume.id;
    });
    return volumeAux.toString().padStart(3, '0');
  };

  const handleGetTag = (): string => {
    const nf = tagData.notfis.numeroNF;
    const serie = tagData.notfis.serieNF;
    let volumeAux = 1;

    tagData.notfis.volumes.forEach((volume) => {
      if (etiqueta.includes(volume.etiqueta.trim())) volumeAux += volume.id;
    });

    return `${nf}${serie}${volumeAux}`;
  };
  return (
    <OrderFastTagContainer>
      <OrderFastTagContent>
        <OrderFastTagContentHeader>
          <img
            src={logo}
            alt="logo"
            style={{
              position: 'absolute',
              filter: 'grayscale(100%) invert(100%) contrast(100%)',
              height: '70px',
              width: '70px',
              padding: '4px',
              top: 0,
              left: 10,
            }}
          />
          <span>{tagData.notfis.codigoRegiao}</span>
          <span>
            {tagData.notfis.dataPrevisaoEntrega &&
              formatarData(new Date(tagData.notfis.dataPrevisaoEntrega), true)}
          </span>
        </OrderFastTagContentHeader>
        <OrderFastTagContentRemetente>
          <strong>REMETENTE:</strong>
          <span>{tagData.notfis.emitente.nome}</span>
        </OrderFastTagContentRemetente>
        <OrderFastTagContentDestinatario>
          <strong>DESTINATÁRIO:</strong>
          <span>{tagData.notfis.consumidor.nome}</span>
          <span style={{ fontSize: 12 }}>
            {tagData.notfis.consumidor.cidade} -{' '}
            {tagData.notfis.consumidor.uf?.toUpperCase()}
          </span>
        </OrderFastTagContentDestinatario>
        <OrderFastTagFooter>
          <OrderFastTagFooterContent>
            <OrderFastTagContentNF>
              <strong>NF-e:</strong>
              <span>{tagData.notfis.numeroNF}</span>
            </OrderFastTagContentNF>
            <OrderFastTagContentVolume>
              <span>
                {handleGetVolume()} /{' '}
                {tagData.notfis.qtdVolumes &&
                  tagData.notfis.qtdVolumes.toString().padStart(3, '0')}
              </span>
            </OrderFastTagContentVolume>
          </OrderFastTagFooterContent>
          <OrderFastTagBarCodeWrapper>
            <Barcode
              value={handleGetTag()}
              width={1.2}
              height={40}
              fontSize={12}
              background=""
            />
          </OrderFastTagBarCodeWrapper>
        </OrderFastTagFooter>
      </OrderFastTagContent>
    </OrderFastTagContainer>
  );
};

const OrderFastTagContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 2px solid black;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 2px solid black;
  position: relative; /* Para criar o efeito de marca d'água */
`;

const OrderFastTagContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const OrderFastTagContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40%;
  border-bottom: 2px solid black;
  background-color: #000;

  span {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 1px;
    color: #fff;
  }
`;
const OrderFastTagContentRemetente = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 50%;
  border-bottom: 2px solid black;

  strong {
    padding: 2px 4px;
    font-size: 10px;
    font-weight: 500;
  }
  span {
    padding: 0px 4px;
    font-size: 14px;
    font-weight: 400;
  }
`;
const OrderFastTagContentDestinatario = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 50%;
  border-bottom: 2px solid black;

  strong {
    padding: 2px 4px;
    font-size: 10px;
    font-weight: 500;
  }
  span {
    padding: 0px 4px;
    font-size: 14px;
    font-weight: 400;
  }
`;

const OrderFastTagContentVolume = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #000;
  width: 100%;
  height: 50%;

  span {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }
`;
const OrderFastTagContentNF = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50%;
  justify-content: center;
  align-items: center;

  strong {
    padding: 4px;
    font-size: 14px;
    font-weight: 500;
  }
  span {
    padding: 4px;
    font-size: 16px;
    font-weight: 500;
  }
`;

const OrderFastTagFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const OrderFastTagFooterContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-right: 2px solid black;
`;

const OrderFastTagBarCodeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export default OrderCbaTag;
